var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ValidatedForm',{class:{ 'narrow-style': _setup.isNarrow },attrs:{"fm":_setup.txReferenceForm.form,"validation":_setup.txReferenceForm.validation},on:{"update:validation":function($event){return _vm.$set(_setup.txReferenceForm, "validation", $event)},"form-event":_setup.onFormEvent}})
}
var staticRenderFns = []

export { render, staticRenderFns }